import {signalStore, withComputed, withState} from "@ngrx/signals";
import {withRoomState} from "./with-room-state.feature";
import {ConfirmationState} from "../../backend/state/confirmation-state.model";
import {Confirmation, ConfirmationResult} from "../../backend/model/confirmation.model";
import {computed, inject} from "@angular/core";
import {PlayerStore} from "./player.store";
import {LobbyType} from "../../backend/state/lobby-state.model";
import {LobbyStore} from "./lobby.store";

const initialState: ConfirmationState = {
  next: {
    result: ConfirmationResult.INACTIVE
  } as Confirmation,
  report: {
    result: ConfirmationResult.INACTIVE
  } as Confirmation,
  playAgain: {
    result: ConfirmationResult.INACTIVE
  } as Confirmation,
  invalidHit: {
    result: ConfirmationResult.INACTIVE
  } as Confirmation
}

export const ConfirmationStore = signalStore(
  withState(initialState),
  withComputed((store, playerStore = inject(PlayerStore), lobbyStore = inject(LobbyStore)) => ({
    nextDisabled: computed(() => {
      const playerId = playerStore.player().id!;
      return store.next().confirmations[playerId] === true;
    }),
    nextCountString: computed(() => {
      const confirmation = store.next();
      const confirmed = Object.keys(confirmation.confirmations).length;
      const target = confirmation.target;
      if (lobbyStore.type() === LobbyType.FREE_FOR_ALL && target > 1) {
        return `(${confirmed}/${target})`;
      } else {
        return '';
      }
    })
  })),
  withRoomState('ConfirmationStore', state => {
    return state.confirmation;
  })
);
